
import FleetReconciliationDetailView from "../../components/FleetReconciliationDetailView";

FleetReconciliationDetailScreen.propTypes = {};

function FleetReconciliationDetailScreen(props) {

    return (
        <div>
            <FleetReconciliationDetailView />
        </div>
    );
}

export default FleetReconciliationDetailScreen;
